// src/components/layout/public/Layout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../common/Header/Header';
import Footer from '../../common/Footer/Footer';
import { LayoutContainer, ContentWrapper, MainContent } from './Layout.styles';

const Layout: React.FC = () => {
  return (
    <LayoutContainer>
      <Header />
      <ContentWrapper>
        <MainContent>
          <Outlet />  {/* This is where nested route components will render */}
        </MainContent>
      </ContentWrapper>
      <Footer />
    </LayoutContainer>
  );
};

export default Layout;
